<template>
  <section>
    <div
      v-for="option in options"
      :key="option.index"
      class="flex flex-col last:mb-0 mb-4"
    >
      <menu-item-option
        :entree="entree"
        :entree-identifier="entreeIdentifier"
        :option="option"
        v-model="selectedOptions[option.index]"
        @is-valid="validateOptions($event, option.index)"
      />
    </div>
  </section>
</template>

<script>
import MenuItemOptions from './MenuItemOptions';

export default MenuItemOptions;
</script>

<style lang="scss" scoped>
@import 'MenuItemOptions';
</style>
